import { FC, useContext } from "react";

import { PaymentMethod, TicketingFormCategory, FormType } from "@simplyk/common";

import { FrontendFormContext } from "@/contexts/FrontendFormContext";
import { FormV2Layout } from "@/features/FormV2/FormV2Layout";
import { FormV2Providers } from "@/features/FormV2/FormV2Providers";
import { CloseEmbedButton } from "@/features/FormV2/sharedComponents/CloseEmbedButton";
import { FormV2LanguageSelect } from "@/features/FormV2/sharedComponents/FormV2LanguageSelect";
import { TicketingThankYouLoader } from "@/features/FormV2/sharedComponents/ThankYouLoaderContainer";
import { AuctionV2Step1 } from "@/features/FormV2/Step1/AuctionV2Step1";
import { TicketingV2Step1 } from "@/features/FormV2/Step1/TicketingV2Step1";
import { FormV2Step2 } from "@/features/FormV2/Step2/FormV2Step2";
import { usePreviewContext } from "@/features/LiveFormEditor/LivePreview/context/PreviewContext";
import { TicketingFrontendPageOutput } from "@/types/trpc";

interface TicketingFormV2PageProps {
  data: TicketingFrontendPageOutput;
  isEmbed?: boolean;
}

export const TicketingFormV2Page: FC<TicketingFormV2PageProps> = ({ data, isEmbed = false }) => {
  const { isPreview } = usePreviewContext();
  const { isSubmitting, selectedPaymentMethod } = useContext(FrontendFormContext);
  const isAuction = data.formCategory === TicketingFormCategory.Auction;

  const displayThankYou = !(selectedPaymentMethod === PaymentMethod.CashApp || !isSubmitting);

  return (
    <FormV2Providers type={FormType.Ticketing} formObject={data} isEmbed={isEmbed}>
      {(currentStep) => (
        <FormV2Layout
          step={currentStep}
          slots={{
            languageSelect: <FormV2LanguageSelect />,
            closeEmbedButton: <CloseEmbedButton />,
            selectionStep: isAuction ? <AuctionV2Step1 isEmbed={isEmbed} /> : <TicketingV2Step1 isEmbed={isEmbed} />,
            paymentStep: <FormV2Step2 />,
            thankYou: displayThankYou ? <TicketingThankYouLoader /> : undefined,
          }}
          preloadSteps={!isPreview}
          withShapes={data.hasShapes}
        />
      )}
    </FormV2Providers>
  );
};
